/* src/app/features/honra/solicitacao-honra/solicitacao-honra-listagem.component.scss */
.moeda {
  text-align: right;
}
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=solicitacao-honra-listagem.component.css.map */
